<div class="loader" *ngIf="_isLoading">
  <sui-loader></sui-loader>
</div>
<ng-container *ngIf="!_isLoading">
  <div class="list-header">
    <div class="left">
      <div class="title" *ngIf="isMine">
        이 그룹책에 남긴 <span class="count">{{ _items.length }}</span
        >건의 밑줄이 있습니다.
      </div>
      <div class="title" *ngIf="!isMine">
        <b>{{ memberName }}님</b>이 이 그룹책에 남긴
        <span class="count">{{ _items.length }}</span
        >개의 밑줄이 있습니다.
      </div>
    </div>
    <div class="right" *ngIf="isMine">
      <button
        class="select-all-button"
        [class.is-active]="
          _selectedItemCount > 0 && _selectedItemCount === _items.length
        "
        (click)="_onSelectAllButtonClick()"
      >
        전체 선택
      </button>
      <select
        sui-select
        [(ngModel)]="_selectedSortType"
        (ngModelChange)="_onSortTypeChange()"
      >
        <option *ngFor="let sortType of _sortTypes" [value]="sortType">
          {{ sortType }}
        </option>
      </select>
    </div>
  </div>
  <div
    class="list"
    #underlineListContainer
    [class.selection-mode]="_selectedItemCount > 0"
  >
    <div class="no-underline" *ngIf="_items?.length === 0">
      <div class="no-underline-text">
        <p class="no-underline-text-title" *ngIf="isMine">
          중요한 문장, 감명 깊은 문장에 밑줄을 그어 <br />
          그룹책 멤버들과 공유하세요
        </p>
        <p class="no-underline-text-title" *ngIf="!isMine">
          다른 그룹책 멤버의 기록도 찾아보세요.
        </p>
      </div>
    </div>
    <div
      class="list-item"
      *ngFor="let item of _items; index as i"
      [class.is-selected]="item.selected"
    >
      <viewer-icon-checkbox
        *ngIf="isMine"
        class="checkbox"
        [class.is-selected]="item.selected"
        ><input
          type="checkbox"
          [(ngModel)]="item.selected"
          (ngModelChange)="_onItemSelectionChange()"
      /></viewer-icon-checkbox>
      <button
        sui-icon-button
        class="more-button"
        [cdkMenuTriggerFor]="menu"
        [cdkMenuPosition]="_menuPosition"
        [cdkMenuTriggerData]="{ item: item }"
      >
        <sui-icon name="더보기 세로형"></sui-icon>
      </button>
      <div class="text" (click)="_onItemClick(item)">
        {{ item.text }}
      </div>
      <div class="bottom-info">
        <div class="date">{{ item.created_at | date : 'y.MM.dd. HH:mm' }}</div>
        <span class="view-text" (click)="_onViewTextClick(item)">본문보기</span>
      </div>
    </div>
  </div>
  <div class="bottom-menu" [class.is-active]="_selectedItemCount > 0">
    <div class="selection-count">
      총 <span>{{ _selectedItemCount }}</span
      >개 선택
    </div>
    <div class="buttons">
      <button
        class="select-cancel-button"
        sui-box-button
        varSize="medium48::medium40::medium40"
        (click)="_onClickSelectCancelButton()"
      >
        선택취소</button
      ><button
        sui-solid-button
        varSize="medium48::medium40::medium40"
        (click)="_onDeleteSelectedItemsButtonClick()"
      >
        삭제하기
      </button>
    </div>
  </div>
</ng-container>

<ng-template #menu let-item="item">
  <sui-menu cdkMenu>
    <button sui-menu-item cdkMenuItem (click)="_onShareUnderline()">
      공유하기
    </button>
    <button
      *ngIf="isMine"
      sui-menu-item
      cdkMenuItem
      (click)="_onDeleteMenuClick(item)"
    >
      삭제하기
    </button>
  </sui-menu>
</ng-template>
